/** fileName: EmptyList.jsx
 * developer: majid.garavand@gmail.com
 * created: 3/17/23
 * note: Do not delete this comment to maintain copyright rules
 * */
import React from 'react';
import {Grid, Typography} from "@mui/material";

const Loading = ({placeHolder=''}) => {
    return (
        <Grid sx={{display: "flex", alignItems: "center", justifyContent: "center", marginX: 'auto',color:'#b6b6b6',marginY:4}}>
            <Typography variant={'h6'}>{placeHolder !== '' ? placeHolder: 'موردی یافت نشد!'}</Typography>
        </Grid>
    );
};

export default Loading;